import Legal from './Legal';
export default Legal;